/* assets/be-quiz.js */
(function () {
  "use strict";

  const root = document.querySelector("[data-be-quiz]");
  if (!root) return;

  const cfgUrl = root.getAttribute("data-config-url");
  const resultsUrlAttr = root.getAttribute("data-results-url") || "";
  const storageKey = root.getAttribute("data-storage-key") || "be_quiz_v1";

  // =========================
  // OMNISEND — REST API PROXY
  // =========================
  // The Omnisend JS SDK and inShop endpoint are tracking-only tools.
  // Subscription status, tags, and custom properties require the REST API,
  // which needs an API key that cannot live in browser JS.
  // All three are handled by the serverless proxy (netlify-quiz-submit.js).
  //
  // Set this to your deployed Netlify function URL once it is live:
  const OMNISEND_PROXY_URL = "https://sparkling-torte-79929d.netlify.app/.netlify/functions/quiz-submit";

  // Legacy inShop constants — kept for reference, no longer called.
  const OMNISEND_BRAND_ID = "66c60897928da5ed8bc9a6f7";
  const OMNISEND_INSHOP_IDENTIFY = "https://wt.omnisendlink.com/REST/inShop/v1/identifyContact";

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
  }

  async function omnisendIdentify({ email, status = "subscribed", tags = [], properties = {} }) {
    const params = new URLSearchParams();
    params.set("email", String(email || "").trim());
    params.set("status", status);
    if (tags && tags.length) params.set("tags", tags.join(","));
    params.set("brandID", OMNISEND_BRAND_ID);
    params.set("shopType", "shopify");
    params.set("responseType", "json");

    const url = `${OMNISEND_INSHOP_IDENTIFY}?${params.toString()}`;
    console.log("[PRQ] Omnisend identify URL:", url);

    const res = await fetch(url, { method: "GET", credentials: "omit" });
    const text = await res.text();
    console.log("[PRQ] Omnisend identify status:", res.status, "body:", text);

    if (!res.ok) throw new Error(`Omnisend identify failed: ${res.status} ${text}`);

    // Push contact properties via Omnisend JS SDK if available
    if (typeof window.omnisend !== "undefined" && typeof window.omnisend.push === "function") {
      try {
        const payload = Object.assign({ email: String(email || "").trim() }, properties);
        window.omnisend.push(["identify", payload]);
        console.log("[PRQ] Omnisend JS identify:", payload);
      } catch (sdkErr) {
        console.warn("[PRQ] Omnisend JS identify failed:", sdkErr);
      }
    }

    try {
      return JSON.parse(text);
    } catch (e) {
      return { raw: text };
    }
  }

  async function omnisendTrackEvent({ email, eventName, properties = {} }) {
    if (typeof window.omnisend === "undefined" || typeof window.omnisend.push !== "function") {
      console.warn("[PRQ] Omnisend JS SDK not available; event not tracked:", eventName);
      return;
    }
    try {
      const payload = Object.assign({ email: String(email || "").trim() }, properties);
      window.omnisend.push(["track", eventName, payload]);
      console.log("[PRQ] Omnisend event tracked:", eventName, payload);
    } catch (e) {
      console.error("[PRQ] Omnisend track failed:", e);
      throw e;
    }
  }

  // Write to the localStorage queue that be-omni-drain.js reads on the results page.
  // The drain waits for window.omnisend to be ready, then fires identifyContact + track.
  // Shape must match what drain expects: { email, event, tags, props }
  function omnisendEnqueue({ email, eventName, tags = [], props = {} }) {
    const key = "__omni_queue_" + Date.now() + "_" + Math.floor(Math.random() * 9999);
    try {
      localStorage.setItem(key, JSON.stringify({
        email: String(email || "").trim(),
        event: eventName,
        tags: tags,
        props: props,
      }));
      console.log("[PRQ] queued for drain:", key);
    } catch (e) {
      console.warn("[PRQ] omnisendEnqueue failed:", e);
    }
  }

  // Primary submission path: POST quiz data to the serverless proxy.
  // The proxy calls POST /v3/contacts (subscribed + tags + customProperties)
  // and POST /v3/events (prq_quiz_completed) using the Omnisend REST API.
  async function omnisendSubmitViaProxy({ email, tags, properties, eventProperties }) {
    const res = await fetch(OMNISEND_PROXY_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: String(email || "").trim(),
        tags,
        properties,
        eventName: "prq_quiz_completed",
        eventProperties,
      }),
    });
    const text = await res.text();
    console.log("[PRQ] proxy result:", res.status, text);
    if (!res.ok) throw new Error("Proxy submit failed: " + res.status + " " + text);
    try { return JSON.parse(text); } catch { return { raw: text }; }
  }

  // =========================
  // DOM HELPERS
  // =========================
  function el(tag, attrs = {}, children = []) {
    const n = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === "class") n.className = v;
      else if (k === "html") n.innerHTML = v;
      else n.setAttribute(k, v);
    });
    children.forEach((c) => n.appendChild(typeof c === "string" ? document.createTextNode(c) : c));
    return n;
  }

  function showFatal(msg) {
    root.innerHTML = '<div class="be-quiz-error">' + msg + "</div>";
  }

  if (!cfgUrl) {
    showFatal(
      'Quiz failed to load: missing <strong>data-config-url</strong> on the <strong>[data-be-quiz]</strong> element.'
    );
    return;
  }

  function saveState(state) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (e) {}
  }

  function loadState() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || "null");
    } catch (e) {
      return null;
    }
  }

  // =========================
  // SCORING
  // =========================
  function scoreAnswer(cfg, q, selectedLabels) {
    const picks = Array.isArray(selectedLabels) ? selectedLabels : [selectedLabels];
    const weights = {};
    (cfg.pillars || []).forEach((p) => (weights[p.id] = 0));

    (q.answers || []).forEach((ans) => {
      if (picks.includes(ans.label)) {
        const sc = ans.score || {};
        Object.keys(sc).forEach((pillarId) => {
          if (weights[pillarId] === undefined) weights[pillarId] = 0;
          weights[pillarId] += Number(sc[pillarId] || 0);
        });
      }
    });

    return weights;
  }

  function mergeWeights(target, add) {
    Object.entries(add || {}).forEach(([k, v]) => {
      if (target[k] === undefined) target[k] = 0;
      target[k] += Number(v || 0);
    });
  }

  function computeScores(cfg, responses) {
    const totals = {};
    (cfg.pillars || []).forEach((p) => (totals[p.id] = 0));

    (cfg.questions || []).forEach((q, idx) => {
      const r = responses[idx];
      if (!r) return;
      if (q.type === "email") return;
      mergeWeights(totals, scoreAnswer(cfg, q, r));
    });

    return totals;
  }

  function bestPillar(cfg, totals) {
    const first = (cfg.pillars && cfg.pillars[0] && cfg.pillars[0].id) || "digestion";
    let best = first;
    let bestScore = -1;

    (cfg.pillars || []).forEach((p) => {
      const s = Number(totals[p.id] || 0);
      if (s > bestScore) {
        best = p.id;
        bestScore = s;
      }
    });

    return { pillar: best, score: bestScore };
  }

  // =========================
  // RENDER
  // =========================
  function render(cfg) {
    const resultsUrl = resultsUrlAttr || cfg.resultsPagePath || "/pages/quiz-results";
    const state = loadState() || { step: 0, responses: [], email: null, emailed: false };

    let step = Math.max(0, Math.min((cfg.questions || []).length - 1, Number(state.step || 0)));
    let responses = Array.isArray(state.responses) ? state.responses : [];
    let emailed = !!state.emailed;

    root.innerHTML = "";

    const prog = el("div", { class: "be-quiz-progress" }, [el("div")]);
    root.appendChild(prog);

    const wrap = el("div", { class: "be-quiz-wrap" });
    root.appendChild(wrap);

    function totalSteps() {
      return Math.max(1, (cfg.questions || []).length);
    }

    function setProgress() {
      const total = totalSteps();
      const denom = Math.max(1, total - 1);
      const pct = (step / denom) * 100;
      prog.firstChild.style.width = Math.max(0, Math.min(100, pct)) + "%";
    }

    function save() {
      saveState({ step, responses, emailed, email: state.email || null });
    }

    function canNext() {
      const q = cfg.questions[step];
      const r = responses[step];
      if (q.type === "email") return true;
      if (q.type === "multi") return Array.isArray(r) && r.length > 0;
      return typeof r === "string" && r.length > 0;
    }

    function finish() {
      const totals = computeScores(cfg, responses);
      const best = bestPillar(cfg, totals);

      saveState({
        step,
        responses,
        totals,
        best,
        emailed,
        email: state.email || null,
        completedAt: new Date().toISOString(),
      });

      window.location.href = resultsUrl;
    }

    function nav() {
      const navEl = el("div", { class: "be-quiz-nav" });

      const back = el("button", { class: "be-quiz-back", type: "button" }, ["← Back"]);
      back.addEventListener("click", () => {
        if (step > 0) {
          step -= 1;
          renderStep();
        }
      });

      const nextLabel = step === cfg.questions.length - 1 ? "VIEW RESULTS" : "NEXT";
      const next = el("button", { class: "be-quiz-next", type: "button" }, [nextLabel]);
      next.disabled = !canNext();

      next.addEventListener("click", () => {
        if (!canNext()) return;
        if (step < cfg.questions.length - 1) {
          step += 1;
          renderStep();
          return;
        }
        finish();
      });

      navEl.appendChild(back);
      navEl.appendChild(next);
      return navEl;
    }

    function renderEmailStep() {
      const gate = cfg.emailGate || {};
      const headline = gate.headline || "Last step!";
      const subhead = gate.subhead || "Enter your email below to see your results.";

      const submitLabel = gate.submitLabel || "Submit and view results";
      const skipLabel = gate.skipLabel || "Skip and view results";

      const card = el("div", { class: "be-quiz-email" });
      card.appendChild(el("div", { class: "be-quiz-title" }, [headline]));
      card.appendChild(el("div", { class: "be-quiz-subtitle" }, [subhead]));

      const inputWrap = el("div", { class: "be-quiz-email-row" });
      const input = el("input", {
        type: "email",
        name: "email",
        placeholder: "Email Address",
        autocomplete: "email",
        inputmode: "email",
        class: "be-quiz-email-input",
      });

      const submit = el("button", { class: "be-quiz-email-submit", type: "button" }, [submitLabel]);
      const err = el("div", { class: "be-quiz-email-error" }, ["Please enter a valid email address."]);
      err.style.display = "none";

      submit.addEventListener("click", async () => {
        const email = String(input.value || "").trim();
        console.log("[PRQ] email submit clicked:", email);

        if (!isValidEmail(email)) {
          err.style.display = "block";
          input.focus();
          return;
        }
        err.style.display = "none";

        const totals = computeScores(cfg, responses);
        const best = bestPillar(cfg, totals);

        // Build tags using pillar_tag_map from config
        const pillarTagMap = cfg.pillar_tag_map || {};
        const pillarTag = pillarTagMap[best.pillar] || ("PRQ_" + best.pillar);
        const tags = ["PRQ_Quiz", "source:prq-quiz", pillarTag];

        // Build contact properties (winning pillar + per-pillar scores)
        const contactProperties = { quiz_pillar: best.pillar };
        (cfg.pillars || []).forEach((p) => {
          contactProperties["quiz_score_" + p.id] = totals[p.id] || 0;
        });

        // Build event properties
        const eventProperties = { pillar: best.pillar, pillar_score: best.score };
        (cfg.pillars || []).forEach((p) => {
          eventProperties["score_" + p.id] = totals[p.id] || 0;
        });

        // UI feedback
        const oldText = submit.textContent;
        submit.disabled = true;
        submit.textContent = "Submitting...";

        // Submit via serverless proxy → Omnisend REST API
        // (handles subscribed status, tags, customProperties, and event)
        try {
          await omnisendSubmitViaProxy({
            email,
            tags,
            properties: contactProperties,
            eventProperties,
          });
        } catch (e) {
          console.error("[PRQ] proxy submit failed:", e);
          // still proceed to results — do not block the user
        }

        // Save + redirect
        emailed = true;
        state.email = email;

        saveState({
          step,
          responses,
          totals,
          best,
          emailed,
          email,
          completedAt: new Date().toISOString(),
        });

        submit.disabled = false;
        submit.textContent = oldText;

        window.location.href = resultsUrl;
      });

      const skip = el("button", { class: "be-quiz-email-skip", type: "button" }, [skipLabel]);
      skip.addEventListener("click", () => {
        emailed = false;
        state.email = null;
        finish();
      });

      inputWrap.appendChild(input);
      inputWrap.appendChild(submit);

      card.appendChild(inputWrap);
      card.appendChild(err);
      card.appendChild(el("div", { class: "be-quiz-email-or" }, ["Or"]));
      card.appendChild(skip);

      card.appendChild(
        el("div", { class: "be-quiz-email-fineprint" }, [
          "By entering your email, you agree to receive educational emails from Body Ecology. You can unsubscribe anytime.",
        ])
      );

      wrap.appendChild(card);
      wrap.appendChild(nav());
      save();
    }

    function renderStep() {
      wrap.innerHTML = "";
      setProgress();

      const q = cfg.questions[step];

      if (q.type === "email") {
        renderEmailStep();
        return;
      }

      wrap.appendChild(el("div", { class: "be-quiz-title" }, [q.title || ""]));
      if (q.subtitle) wrap.appendChild(el("div", { class: "be-quiz-subtitle" }, [q.subtitle]));

      const grid = el("div", { class: "be-quiz-grid " + (q.layout === "two" ? "two" : "") });
      const selected = responses[step] || (q.type === "multi" ? [] : null);

      function isSelected(label) {
        if (q.type === "multi") return Array.isArray(selected) && selected.includes(label);
        return selected === label;
      }

      (q.options || []).forEach((optLabel) => {
        const b = el(
          "button",
          { class: "be-quiz-btn" + (isSelected(optLabel) ? " selected" : ""), type: "button" },
          [optLabel]
        );

        b.addEventListener("click", () => {
          if (q.type === "multi") {
            let cur = Array.isArray(responses[step]) ? responses[step].slice() : [];
            if (cur.includes(optLabel)) cur = cur.filter((x) => x !== optLabel);
            else cur.push(optLabel);
            responses[step] = cur;
            renderStep();
            return;
          }

          responses[step] = optLabel;
          save();

          if (step < cfg.questions.length - 1) {
            step += 1;
            renderStep();
            return;
          }

          finish();
        });

        grid.appendChild(b);
      });

      wrap.appendChild(grid);
      wrap.appendChild(nav());
      save();
    }

    renderStep();
  }

  // =========================
  // LOAD CONFIG + START
  // =========================
  fetch(cfgUrl, { credentials: "same-origin" })
    .then((r) => {
      if (!r.ok) throw new Error("Config fetch failed: " + r.status);
      return r.json();
    })
    .then((cfg) => {
      (cfg.questions || []).forEach((q) => {
        if (!q.options) q.options = (q.answers || []).map((a) => a.label);
      });

      if (cfg.emailGate && cfg.emailGate.enabled) {
        cfg.questions = cfg.questions || [];
        const last = cfg.questions[cfg.questions.length - 1];
        if (!last || last.type !== "email") {
          cfg.questions.push({
            id: "email_gate",
            type: "email",
            title: cfg.emailGate.headline || "Last step!",
            subtitle: cfg.emailGate.subhead || "",
            answers: [],
          });
        }
      }

      render(cfg);
    })
    .catch((err) => {
      showFatal(
        'Quiz failed to load. <strong>be-quiz-config.json</strong> must be valid JSON and accessible.' +
          "<br><br><small>" +
          String(err && err.message ? err.message : err) +
          "</small>"
      );
      console.error(err);
    });
})();